import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';

export function useReportCsvExport(filename: string, exportFn: () => Promise<Blob>) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const exportCsv = useCallback(async () => {
    setLoading(true);
    try {
      const blob = await exportFn();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
      enqueueSnackbar('Report downloaded.', { variant: 'success' });
    } catch (e: unknown) {
      const message = e && typeof e === 'object' && 'message' in e ? String((e as { message?: string }).message) : '';
      enqueueSnackbar(message || 'Failed to export CSV', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, exportFn, filename]);

  return { exportCsv, loading };
}
